/* Ecochic · Rutinas en Eurus (FLUJO_FRONTEND_ECOCHIC_v1 §5).
   Motor portado de web-v3/js/engines.js (window.Routines + window.Usage) y vista de web-v3/js/views/rutinas.js.
   Correcciones al portar (FLUJO §5 y PLAN v2 §4): «aceite esencial» ya no cae en Tonificar; lo corporal
   se excluye antes de «crema»; el listener de clics se añade una sola vez (sin doble alta en la cesta);
   «Añadir a mi rutina» añade a la rutina guardada sin borrarla (regla 29, semántica unificada).
   Los textos vienen de los ajustes de la sección (script#eco-routines-config). */
(function () {
  'use strict';
  var host = document.getElementById('eco-routines');
  var T = {};
  try { T = JSON.parse(document.getElementById('eco-routines-config').textContent) || {}; } catch (e) {}
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function na(s) { return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function priceNum(p) { var n = parseFloat(p && p.price); return isNaN(n) || n === 0 ? null : n; }
  function eur(v) { var n = parseFloat(v); return (isNaN(n) || n === 0) ? '' : n.toFixed(2).replace('.', ',') + ' €'; }
  function LS() { return (window.Eco && Eco.LS) || { get: function () { return null; }, set: function () {} }; }
  function Profile() { return window.Eco && Eco.Profile; }
  /* Ajuste del tema «Activar el perfil de piel» apagado: sin «Tu rutina», sin invitación al diagnóstico y sin «Añadir a mi rutina» */
  var PERFIL_OFF = !!(window.ECO_DATA && ECO_DATA.perfil === false);

  /* producto del catálogo → formato de eco-core (para evaluate / fitTag) */
  function ecoP(p) {
    try {
      var ex = (window.PRODUCTS_EXTRA || {})[p.h] || {};
      return Eco.data.toP({ handle: p.h, title: p.t, description: p.desc, product_type: p.product_type || p.type, tags: p.tags,
        custom: { inci: p.inci, activos_clave: ex.activos || [], tipos_piel: ex.piel || [] } });
    } catch (e) { return null; }
  }

  /* ---------- motor (web-v3/js/engines.js:14-75) ---------- */
  // Pasos: metaobjeto «Vocabulario» (grupo paso_rutinas, en orden; basta con que aparezca la palabra) y exclusión no facial (grupo no_facial, clave «rutinas»).
  // SPF y limpieza se reconocen antes de la exclusión (un SPF corporal o un limpiador sirven); el resto, después.
  var D = window.ECO_DATA || {};
  var PASOS = D.group ? D.group('paso_rutinas') : [];
  var NOFAC = (D.group ? D.group('no_facial') : []).filter(function (v) { return v.key === 'rutinas'; })[0] || { kw: [], rel: [] };
  function any(t, kw) { return (kw || []).some(function (k) { return t.indexOf(na(k)) >= 0; }); }
  function slotOf(p) {
    var t = na(p.t) + ' ' + na(p.product_type || p.type), i, v;
    for (i = 0; i < PASOS.length; i++) { v = PASOS[i]; if ((v.key === 'spf' || v.key === 'limpiador') && any(t, v.kw)) return v.key; }
    if (any(t, NOFAC.kw) && !any(t, NOFAC.rel)) return null; // corrección: corporal y aceite esencial fuera
    for (i = 0; i < PASOS.length; i++) { v = PASOS[i]; if (v.key !== 'spf' && v.key !== 'limpiador' && any(t, v.kw)) return v.key; }
    return null;
  }
  function matchConcern(p, concern) {
    if (!concern) return 0;
    var hay = na(p.t) + ' ' + na((p.tags || []).join(' ')) + ' ' + na(p.desc) + ' ' + na(p.inci), c = na(concern);
    var s = hay.indexOf(c) >= 0 ? 2 : 0;
    (window.INGREDIENTS || []).forEach(function (ing) {
      if ((ing.dolencias || []).some(function (d) { return na(d).indexOf(c) >= 0 || c.indexOf(na(d)) >= 0; })) {
        var key = na(ing.nombre).split(' ')[0];
        if (key.length > 3 && hay.indexOf(key) >= 0) s += 2;
      }
    });
    return s;
  }
  function matchSkin(p, skin) { if (!skin) return 0; return (na((p.tags || []).join(' ')) + ' ' + na(p.desc)).indexOf(na(skin)) >= 0 ? 1 : 0; }

  var SLOT_ORDER = ['limpiador', 'tonico', 'tratamiento', 'contorno', 'hidratante', 'spf', 'extra'];
  var SLOT_LABEL = { limpiador: EcoT('rutinas.limpiar'), tonico: EcoT('rutinas.tonificar'), tratamiento: EcoT('rutinas.tratar'), contorno: EcoT('rutinas.contorno'), hidratante: EcoT('rutinas.hidratar'), spf: EcoT('rutinas.proteger_spf'), extra: EcoT('rutinas.extra_semanal') };
  var SLOT_WHEN = { limpiador: EcoT('rutinas.manana_y_noche'), tonico: EcoT('rutinas.manana_y_noche'), tratamiento: EcoT('rutinas.segun_activo_ver_ficha'), contorno: EcoT('rutinas.manana_y_noche'), hidratante: EcoT('rutinas.manana_y_noche'), spf: EcoT('rutinas.cada_manana'), extra: EcoT('rutinas.1_2_veces_semana') };

  function pickBySlot(opts) {
    var P = (window.PRODUCTS || []).filter(function (p) { return slotOf(p) !== null && p.available !== false; });
    var used = {}, steps = [];
    var slots = ['limpiador', 'tratamiento', 'hidratante', 'spf'];
    if (opts.goals && opts.goals.indexOf('exfoliar') >= 0) slots.push('extra');
    if (opts.skin === 'madura' || (opts.concerns || []).indexOf('arrugas') >= 0) slots.push('contorno');
    var PR = Profile();
    SLOT_ORDER.forEach(function (sl) {
      if (slots.indexOf(sl) < 0) return;
      var cands = P.filter(function (p) { return slotOf(p) === sl && !used[p.h]; }).map(function (p) {
        var sc = 0, reasons = [];
        (opts.concerns || []).forEach(function (c) { var m = matchConcern(p, c); if (m) { sc += m; reasons.push(c); } });
        sc += matchSkin(p, opts.skin);
        var pr = priceNum(p); if (opts.budgetCap && pr && pr > opts.budgetCap) sc -= 1;
        var ev = null; try { ev = PR ? PR.evaluate(ecoP(p)) : null; } catch (e) {}
        return { p: p, score: sc, reasons: reasons, blocked: ev && ev.status === 'avoid' };
      }).filter(function (x) { return !x.blocked; });
      cands.sort(function (a, b) { return b.score - a.score || ((priceNum(b.p) ? 0 : 1) - (priceNum(a.p) ? 0 : 1)); });
      if (cands.length) {
        var win = cands[0]; used[win.p.h] = 1;
        steps.push({ slot: sl, label: SLOT_LABEL[sl], when: SLOT_WHEN[sl], product: win.p,
          why: win.reasons.length ? (EcoT('rutinas.para')+' ' + win.reasons.join(', ') + '.') : (SLOT_LABEL[sl] + ' '+EcoT('rutinas.paso_base_de_la_rutina')),
          approx: win.reasons.length === 0 });
      }
    });
    return steps;
  }
  /* momento del día de un paso (mañana / noche / semanal): también fuera de la página de Rutinas (diagnóstico, Mi cuenta) */
  function nightActive(p) { return !!p && !!(D.has && D.has((p.t || '') + ' ' + (p.desc || '') + ' ' + (p.inci || '') + ' ' + (p.tags || []).join(' '), D.list('activo_noche'))); }
  var WHEN = { manana_y_noche: [true, true, 'rutinas.manana_y_noche_2'], manana: [true, false, 'rutinas.cada_manana_2'], noche: [false, true, 'rutinas.solo_de_noche'], semanal: [false, true, 'rutinas.1_2_veces_semana_noche'] };
  function whenInfo(s) {
    // k = clave estable del momento (manana_y_noche, manana, noche, semanal): la usan Mi cuenta y el PDF, sin leer textos
    function wi(k) { var w = WHEN[k]; return { k: k, am: w[0], pm: w[1], label: EcoT(w[2]) }; }
    if (s.momento && WHEN[s.momento]) return wi(s.momento);
    if (s.momento === 'segun_activo') return wi(nightActive(s.product) ? 'noche' : 'manana_y_noche');
    if (s.slot === 'spf') return wi('manana');
    if (s.slot === 'extra') return wi('semanal');
    if (s.slot === 'tratamiento' && nightActive(s.product)) return wi('noche');
    return wi('manana_y_noche');
  }
  function slim(p) { return p ? { h: p.h, t: p.t, img: p.img, price: p.price, brand: p.brand, inci: p.inci, tags: p.tags, desc: '' } : p; }
  function hOf(s) { return (s && (s.handle || (s.product && s.product.h))) || ''; }
  function isManual(s) { return !!s && (s.slot === 'producto' || s.manual === true); }
  function byH(h) { try { return (window.EcoCatalog && EcoCatalog.byHandle(h)) || null; } catch (e) { return null; } }
  /* paso guardado: handle, producto reducido y momento del día (whenInfo; los añadidos a mano conservan el suyo) */
  function normStep(s) {
    if (!s.product && s.handle) s.product = byH(s.handle) || null;
    if (!isManual(s) && s.slot) {
      // el paso «extra» del diagnóstico agrupa contorno, exfoliante y mascarilla: manda el paso real del producto
      var ws = s.slot === 'extra' && s.product ? (slotOf(s.product) || 'extra') : s.slot;
      try { var wn = whenInfo({ slot: ws, momento: s.momento, product: s.product }); s.when = wn.label; s.whenKey = wn.k; } catch (e) {}
    }
    s.product = slim(s.product);
    if (s.product && !s.handle) s.handle = s.product.h;
  }
  function totalOf(steps) { return steps.reduce(function (a, s) { return a + (priceNum(s.product || byH(hOf(s))) || 0); }, 0); }
  var Routines = {
    buildForConcern: function (concern) { return { title: EcoT('rutinas.rutina_para')+' ' + concern, concern: concern, steps: pickBySlot({ concerns: concern ? [concern] : [] }) }; },
    buildForSkin: function (skin) { return { title: EcoT('rutinas.rutina_para_piel')+' ' + skin, skin: skin, steps: pickBySlot({ skin: skin }) }; },
    buildForProfile: function () {
      var pr = Profile() && Profile().get(); if (!pr) return null;
      var bv = pr.budget ? (D.group ? D.group('presupuesto') : []).filter(function (x) { return x.key === pr.budget; })[0] : null;
      var cap = bv ? bv.value : null; // metaobjeto «Vocabulario», grupo presupuesto («Valor» = techo)
      // Defecto 8: los objetivos actúan a través de sus dolencias («Vocabulario», grupo objetivo_diagnostico, «relacionadas»)
      var concerns = (pr.concerns || []).slice(), GD = D.group ? D.group('objetivo_diagnostico') : [];
      (pr.goals || []).forEach(function (g) { GD.forEach(function (v) { if (v.key === g) (v.rel || []).forEach(function (c) { if (concerns.indexOf(c) < 0) concerns.push(c); }); }); });
      var steps = pickBySlot({ concerns: concerns, skin: pr.skin, goals: pr.goals || [], budgetCap: cap });
      var total = steps.reduce(function (a, s) { return a + (priceNum(s.product) || 0); }, 0);
      return { title: EcoT('rutinas.tu_rutina'), profile: true, steps: steps, total: total, budget: pr.budget, approx: steps.some(function (s) { return s.approx; }) };
    },
    getSaved: function () { try { return JSON.parse(LS().get('eco_routine') || 'null'); } catch (e) { return null; } },
    /* C388: sin permiso «perfil_piel» no se guarda (devuelve false); quien guarda desde un botón pide antes el permiso (ask) */
    save: function (r) {
      if (!(window.EcoConsent && EcoConsent.has('perfil_piel'))) return false;
      var copy = JSON.parse(JSON.stringify(r));
      (copy.steps || []).forEach(normStep);
      var tot = totalOf(copy.steps || []); if (tot) copy.total = tot; else delete copy.total;
      LS().set('eco_routine', JSON.stringify(copy));
      return true;
    },
    /* «Guardar esta rutina» y el guardado del diagnóstico (FLUJO §5, reglas 28-29): se FUSIONA con la guardada.
       Se conservan los pasos añadidos a mano (slot «producto»), un paso nuevo sustituye al del mismo slot
       y no se repite ningún producto (por handle). */
    merge: function (r) {
      if (!r) return null;
      var old = Routines.getSaved(), add = (r.steps || []).slice();
      var slots = {}, hs = {}, out = [];
      add.forEach(function (s) { if (s.slot && !isManual(s)) slots[s.slot] = 1; });
      add.forEach(function (s) { var h = hOf(s); if (h && hs[h]) return; if (h) hs[h] = 1; out.push(s); });
      ((old && old.steps) || []).forEach(function (s) {
        var h = hOf(s); if (h && hs[h]) return;
        if (!isManual(s) && s.slot && slots[s.slot]) return;
        if (h) hs[h] = 1; out.push(s);
      });
      var m = {}; Object.keys(old || {}).forEach(function (k) { m[k] = old[k]; }); Object.keys(r).forEach(function (k) { m[k] = r[k]; });
      m.steps = out; m.approx = out.some(function (s) { return s.approx; });
      Routines.save(m);
      return m;
    },
    whenOf: function (s) { return whenInfo(s); },
    slotOf: slotOf
  };

  /* ---------- modo de uso (web-v3/js/engines.js:120-146) ---------- */
  var GEN = {
    limpiador: EcoT('rutinas.aplica_sobre_rostro_humedo_con_movimie'),
    tonico: EcoT('rutinas.tras_limpiar_aplica_con_las_manos_o_un'),
    tratamiento: EcoT('rutinas.sobre_la_piel_limpia_y_seca_aplica_una'),
    contorno: EcoT('rutinas.aplica_una_cantidad_pequena_con_toques'),
    hidratante: EcoT('rutinas.extiende_sobre_rostro_y_cuello_como_ul'),
    spf: EcoT('rutinas.uso_spf'),
    extra: EcoT('rutinas.uso_extra'),
    otros: EcoT('rutinas.sigue_las_indicaciones_de_la_ficha_del')
  };
  var Usage = {
    get: function (p) {
      var ex = (window.PRODUCTS_EXTRA || {})[p.h];
      var real = ex && ex.modo_uso;
      if (real && String(real).trim().length > 8) return { source: 'real', text: String(real).trim() };
      var k = slotOf(p); return { source: 'generico', text: GEN[k] || GEN.otros };
    }
  };

  function withConsent(run) {
    if (window.EcoConsent && EcoConsent.has('perfil_piel')) { run(); return; }
    if (window.EcoConsent) EcoConsent.ask('perfil_piel').then(run, function () {});
  }
  /* «Añadir a mi rutina»: se añade a la rutina guardada, sin duplicar (reglas 26, 27 y 29) */
  function addToMyRoutine(step) {
    var r = Routines.getSaved();
    if (!r || !Array.isArray(r.steps)) r = { title: EcoT('rutinas.mi_rutina'), custom: true, steps: [] };
    var h = step.product && step.product.h;
    if (r.steps.some(function (x) { return (x.product && x.product.h === h) || x.handle === h; })) return 'dup';
    r.custom = true;
    r.steps.push(step);
    return Routines.save(r) === false ? 'consent' : 'ok';
  }

  Routines.buildForGuide = function (g) { return buildForGuide(g); };
  window.EcoRoutines = Routines;
  window.EcoUsage = Usage;
  window.EcoRoutines.addToMyRoutine = addToMyRoutine;

  if (!host) return;

  /* ---------- vista (web-v3/js/views/rutinas.js) ---------- */
  // Rutinas guía: Contenido › Metaobjetos › Rutina guía (script#eco-routine-guides). Sin datos fijos en el código.
  var GUIDES = [];
  try { GUIDES = JSON.parse(document.getElementById('eco-routine-guides').textContent) || []; } catch (e) {}
  var CONCERNS = GUIDES.filter(function (g) { return g.grupo === 'dolencia'; });
  var GOALS = GUIDES.filter(function (g) { return g.grupo === 'objetivo'; });
  var CMAP = {}, GMAP = {};
  CONCERNS.forEach(function (g) { CMAP[g.clave] = g.nombre; }); GOALS.forEach(function (g) { GMAP[g.clave] = g.nombre; });
  var BUD = {}; (D.group ? D.group('presupuesto') : []).forEach(function (v) { BUD[v.key] = [v.label, v.value]; }); // «Vocabulario», grupo presupuesto

  function buildForGuide(g) {
    var P = (window.PRODUCTS || []).filter(function (p) { return p.available !== false && !(D.isService && D.isService(p.h)); });
    var PR = Profile(), used = {}, steps = [];
    (g.pasos || []).forEach(function (st) {
      var types = String(st.tipos || '').split(',').map(function (t) { return na(t.trim()); }).filter(Boolean);
      var win = st.producto ? (window.EcoCatalog && EcoCatalog.byHandle(st.producto)) : null, reasons = [];
      if (!win) {
        var cands = P.filter(function (p) { return !used[p.h] && types.indexOf(na(p.product_type || '')) >= 0; }).map(function (p) {
          var sc = 0, rs = [];
          (g.dolencias || []).forEach(function (c) { var m = matchConcern(p, c); if (m) { sc += m; rs.push(CMAP[c] || c); } });
          var ev = null; try { ev = PR ? PR.evaluate(ecoP(p)) : null; } catch (e) {}
          return { p: p, score: sc, reasons: rs, blocked: ev && ev.status === 'avoid' };
        }).filter(function (x) { return !x.blocked; });
        cands.sort(function (a, b) { return b.score - a.score || ((priceNum(b.p) ? 0 : 1) - (priceNum(a.p) ? 0 : 1)) || ((b.p.inci ? 1 : 0) - (a.p.inci ? 1 : 0)); });
        if (cands.length) { win = cands[0].p; reasons = cands[0].reasons; }
      }
      if (!win) return;
      used[win.h] = 1;
      steps.push({ slot: slotOf(win) || 'extra', label: st.etiqueta || '', momento: st.momento || '', product: win,
        why: st.porque || (reasons.length ? EcoT('rutinas.para') + ' ' + reasons.join(', ') + '.' : (st.etiqueta || '') + ' ' + EcoT('rutinas.paso_base_de_la_rutina')),
        approx: !st.porque && !st.producto && !reasons.length });
    });
    return { title: g.nombre, guide: g.clave, steps: steps };
  }
  var REG = {}, SEQ = 0;
  function regStep(s) { var id = 'rt' + (SEQ++); REG[id] = s; return id; }

  function secHead(eyebrow, title) { return '<div class="rt-head"><p class="rt-eyebrow">' + esc(eyebrow) + '</p>' + (title ? '<h2 class="rt-title h3">' + esc(title) + '</h2>' : '') + '</div>'; }
  function timeline(steps) {
    function seq(arr, empty) { return arr.length ? arr.map(function (s) { return esc(s.label); }).join(' <span class="rt-arrow">→</span> ') : '<span class="rt-muted">' + empty + '</span>'; }
    return '<div class="rt-tl">' +
      '<div class="rt-tlcard"><p class="rt-eyebrow">'+EcoT('rutinas.rutina_de_manana')+'</p><div class="rt-seq">' + seq(steps.filter(function (s) { return whenInfo(s).am; }), EcoT('rutinas.sin_pasos_de_manana')) + '</div></div>' +
      '<div class="rt-tlcard"><p class="rt-eyebrow">'+EcoT('rutinas.rutina_de_noche')+'</p><div class="rt-seq">' + seq(steps.filter(function (s) { return whenInfo(s).pm; }), EcoT('rutinas.sin_pasos_de_noche')) + '</div></div></div>';
  }
  function fitHTML(p) { try { var t = Eco.fitTag(ecoP(p), true); return t ? ' ' + t : ''; } catch (e) { return ''; } }
  function stepCard(s) {
    var p = s.product || {}, id = regStep(s), w = whenInfo(s), price = eur(p.price), url = p.u || (ROOT + 'products/' + (p.h || ''));
    var use = null; try { use = Usage.get(p); } catch (e) {}
    return '<div class="rt-step">' +
      (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.t || '') + '" loading="lazy">' : '<span class="rt-noimg"></span>') +
      '<div class="rt-body">' +
        '<p class="rt-eyebrow">' + esc(s.label || '') + ' · <span class="rt-when">' + esc(w.label) + '</span></p>' +
        '<a class="rt-name" href="' + esc(url) + '">' + esc(p.t || EcoT('rutinas.sin_nombre')) + '</a>' +
        '<div class="rt-brand">' + esc(p.brand || EcoT('rutinas.clean_beauty')) + fitHTML(p) + '</div>' +
        '<div class="rt-why">' + esc(s.why || '') + (s.approx ? ' <span class="rt-badge">' + EcoT('rutinas.aproximado') + '</span>' : '') + '</div>' +
        (use ? '<div class="rt-use"><span class="rt-badge">' + (use.source === 'real' ? EcoT('rutinas.modo_de_uso') : EcoT('rutinas.uso_orientativo')) + '</span> ' + esc(use.text) + '</div>' : '') +
        '<div class="rt-price">' + (price || '<span class="rt-muted">' + EcoT('core.consultar') + '</span>') + '</div>' +
        '<div class="rt-acts">' +
          '<a class="button button-outline eco-btn leading-normal text-center pl-7 pr-7 pt-2.5 pb-2.5 md:pl-8 md:pr-8 md:pt-3 md:pb-3" href="' + esc(url) + '">'+EcoT('rutinas.ver_ficha')+'</a>' +
          '<button class="button button-solid eco-btn leading-normal text-center pl-7 pr-7 pt-2.5 pb-2.5 md:pl-8 md:pr-8 md:pt-3 md:pb-3" type="button" data-add="' + esc(p.h || '') + '">'+EcoT('rutinas.anadir_a_la_cesta')+'</button>' +
          (PERFIL_OFF ? '' : '<button class="button button-outline eco-btn leading-normal text-center pl-7 pr-7 pt-2.5 pb-2.5 md:pl-8 md:pr-8 md:pt-3 md:pb-3" type="button" data-saveone="' + id + '">'+EcoT('rutinas.anadir_a_mi_rutina')+'</button>') +
        '</div></div></div>';
  }
  function routineBlock(r, opts) {
    opts = opts || {};
    if (!r || !r.steps || !r.steps.length) return '<div class="rt-box"><p class="rt-muted">' + esc(T.empty_guide || '') + ' <a href="' + esc(T.catalog_url || (ROOT + 'collections/all')) + '">' + esc(T.catalog_label || EcoT('rutinas.catalogo')) + '</a>.</p></div>';
    var anyApprox = r.approx || r.steps.some(function (s) { return s.approx; });
    var html = (opts.banner || '') + timeline(r.steps) + '<div class="rt-steps">' + r.steps.map(stepCard).join('') + '</div>';
    if (opts.note) html += '<p class="rt-note">' + esc(opts.note) + '</p>';
    if (anyApprox && T.note_approx) html += '<p class="rt-note">' + esc(T.note_approx) + '</p>';
    if (T.note_order) html += '<p class="rt-note">' + esc(T.note_order) + '</p>';
    if (opts.saveAll) html += '<div class="rt-saveall"><button class="button button-solid eco-btn leading-normal text-center pl-7 pr-7 pt-2.5 pb-2.5 md:pl-8 md:pr-8 md:pt-3 md:pb-3" type="button" data-saveall="1">' + esc(T.save_label || EcoT('rutinas.guardar_esta_rutina')) + '</button></div>';
    return html;
  }
  function profileBanner(r) {
    var pr = (Profile() && Profile().get()) || {};
    var bits = [EcoT('rutinas.piel')+' ' + (pr.skin || EcoT('rutinas.sin_especificar'))];
    if (pr.concerns && pr.concerns.length) bits.push(pr.concerns.map(function (k) { return CMAP[k] || k; }).join(', '));
    if (pr.goals && pr.goals.length) bits.push(EcoT('rutinas.objetivos_dos_puntos') + ' ' + pr.goals.map(function (k) { return GMAP[k] || k; }).join(', '));
    var bud = pr.budget ? BUD[pr.budget] : null; if (bud) bits.push(EcoT('rutinas.presupuesto')+' ' + bud[0].toLowerCase());
    var cap = bud ? bud[1] : null, totalTxt = r.total ? eur(r.total) : null, over = cap != null && r.total > cap;
    var head = over
      ? '<strong>'+EcoT('rutinas.tu_rutina_suma')+' ' + totalTxt + ' '+EcoT('rutinas.por_compra_y_supera_tu_techo_de')+' ' + esc(bud[0]) + '.</strong><div class="fb-reason">'+EcoT('rutinas.prioriza_limpieza_tratamiento_spf_y_po')+'</div>'
      : '<strong>' + (totalTxt ? (EcoT('rutinas.tu_rutina_suma')+' ' + totalTxt + ' '+EcoT('rutinas.por_compra')) : EcoT('rutinas.rutina_personalizada')) + '.</strong><div class="fb-reason">' + esc(bits.join(' · ')) + (totalTxt ? ' · ' + EcoT('rutinas.solo_se_suman_con_precio') : '') + '</div>';
    return '<div class="fit-banner ' + (over ? 'fit-caution' : 'fit-apt') + '"><div>' + head + '</div></div>';
  }

  function paint() {
    REG = {}; SEQ = 0;
    var P = Profile(), perso = !!(P && P.personalized());
    var html = '';
    if (PERFIL_OFF) {
      // nada personal: la página empieza por las rutinas guía
    } else if (perso) {
      var r = null; try { r = Routines.buildForProfile(); } catch (e) {}
      html += '<div class="rt-sec rt-sec--first">' + secHead(T.mine_eyebrow || EcoT('rutinas.personalizada'), T.mine_title || EcoT('rutinas.tu_rutina'));
      html += (r && r.steps && r.steps.length) ? routineBlock(r, { banner: profileBanner(r), saveAll: true }) : '<div class="rt-box"><p class="rt-muted">' + esc(T.empty_profile || '') + '</p></div>';
      html += '</div>';
    } else {
      html += '<div class="rt-sec rt-sec--first"><div class="rt-box"><p class="rt-eyebrow">' + esc(T.noprof_eyebrow || EcoT('rutinas.aun_sin_perfil')) + '</p>' +
        '<h3 class="rt-boxtitle">' + esc(T.noprof_title || '') + '</h3>' + (T.noprof_text ? '<p class="rt-muted">' + esc(T.noprof_text) + '</p>' : '') +
        '<a class="button button-solid eco-btn leading-normal text-center pl-7 pr-7 pt-2.5 pb-2.5 md:pl-8 md:pr-8 md:pt-3 md:pb-3" href="' + esc(T.diag_url || '/pages/perfil-de-piel') + '">' + esc(T.diag_label || EcoT('rutinas.diagnostica_tu_piel')) + '</a></div></div>';
    }
    html += '<div class="rt-sec' + (PERFIL_OFF ? ' rt-sec--first' : '') + '">' + secHead(T.concern_eyebrow || EcoT('rutinas.por_dolencia'), T.concern_title || EcoT('rutinas.rutinas_guia')) +
      (T.concern_text ? '<p class="rt-muted rt-lead">' + esc(T.concern_text) + '</p>' : '') +
      '<div class="rt-chips" data-group="c">' + CONCERNS.map(function (g) { return '<button class="rt-chip" type="button" aria-pressed="false" data-c="' + esc(g.clave) + '">' + esc(g.nombre) + '</button>'; }).join('') + '</div>' +
      '<div data-out="c"></div></div>';
    html += '<div class="rt-sec">' + secHead(T.goal_eyebrow || EcoT('rutinas.por_objetivo'), T.goal_title || EcoT('rutinas.que_quieres_conseguir')) +
      '<div class="rt-chips" data-group="g">' + GOALS.map(function (g) { return '<button class="rt-chip" type="button" aria-pressed="false" data-g="' + esc(g.clave) + '">' + esc(g.nombre) + '</button>'; }).join('') + '</div>' +
      '<div data-out="g"></div></div>';
    host.innerHTML = html;
  }
  function pick(group, btn) {
    host.querySelectorAll('[data-group="' + group + '"] .rt-chip').forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); });
    btn.classList.add('on'); btn.setAttribute('aria-pressed', 'true');
    var out = host.querySelector('[data-out="' + group + '"]'), rr = null, note = null;
    var list = group === 'c' ? CONCERNS : GOALS, key = btn.getAttribute(group === 'c' ? 'data-c' : 'data-g'), g = null;
    list.forEach(function (x) { if (x.clave === key) g = x; });
    try { rr = g ? buildForGuide(g) : null; } catch (e) {}
    if (g && g.nota) note = g.nota;
    out.innerHTML = secHead(EcoT('rutinas.rutina'), group === 'c' ? EcoT('rutinas.para') + ' ' + btn.textContent : btn.textContent) + routineBlock(rr, { note: note });
  }
  function flash(b, txt, back) { b.textContent = txt; if (back) setTimeout(function () { b.textContent = back; }, 1600); }

  function init() {
    if (!host) return; // en otras páginas solo se usa el motor (EcoRoutines)
    if (!window.Eco || !window.EcoCatalog) { host.innerHTML = '<div class="rt-box"><p class="rt-muted">'+EcoT('rutinas.no_se_han_podido_cargar_las_rutinas_re')+'</p></div>'; return; }
    host.innerHTML = '<div class="rt-box"><p class="rt-muted">' + esc(T.loading || EcoT('rutinas.cargando_el_catalogo')) + '</p></div>';
    // un solo listener (defecto del prototipo corregido)
    host.addEventListener('click', function (e) {
      var c = e.target.closest('[data-c]'); if (c) { pick('c', c); return; }
      var g = e.target.closest('[data-g]'); if (g) { pick('g', g); return; }
      var add = e.target.closest('[data-add]');
      if (add) { EcoCart.add(add.getAttribute('data-add')).then(function (n) { flash(add, n ? EcoT('core.anadido') : EcoT('rutinas.no_disponible'), EcoT('rutinas.anadir_a_la_cesta')); }, function () { flash(add, EcoT('rutinas.no_se_pudo_anadir'), EcoT('rutinas.anadir_a_la_cesta')); }); return; }
      // C388: «Añadir a mi rutina» y «Guardar esta rutina» piden el permiso «perfil_piel» (bloque 4.1) y guardan solo al aceptar
      var so = e.target.closest('[data-saveone]');
      if (so) { var st = REG[so.getAttribute('data-saveone')]; if (st) withConsent(function () { addToMyRoutine(st); flash(so, EcoT('rutinas.en_tu_rutina')); }); return; }
      var sa = e.target.closest('[data-saveall]');
      if (sa) withConsent(function () { try { Routines.merge(Routines.buildForProfile()); flash(sa, EcoT('rutinas.rutina_guardada')); } catch (x) {} });
    });
    Eco.Profile.on(function () { if (window.PRODUCTS) paint(); });
    EcoCatalog.load().then(paint, function () { host.innerHTML = '<div class="rt-box"><p class="rt-muted">'+EcoT('rutinas.no_se_ha_podido_cargar_el_catalogo_rec')+'</p></div>'; });
  }
  // arranque robusto: espera a eco-core.js (se carga al final del body) sin depender del orden de DOMContentLoaded
  (function boot(n) { if (window.Eco || n > 200) init(); else setTimeout(function () { boot(n + 1); }, 30); })(0);
})();
